import { isCancelled, useModalPromise } from '@cp/shared/modal';
import { AsyncResult, Result } from '@cp/shared/result';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clientFavoritesSlice } from '@cp/entities/client';
import { useInjection } from '@cp/shared/di';
import { coreClientAuthApi } from 'src/entities/client';
import { LOGOUT_MODAL } from '../lib';
import { NOTIFICATION_UNSUBSCRIBE_FEATURE } from '../di';
import { AuthError, unknownToAuthError } from './AuthError';

export const useLogout = () => {
  const dispatch = useDispatch();
  const unsubscribeNotifications = useInjection(NOTIFICATION_UNSUBSCRIBE_FEATURE);
  const [logoutRequest] = coreClientAuthApi.useLogoutMutation();
  const confirmLogout = useModalPromise(LOGOUT_MODAL);

  return useCallback(async (): AsyncResult<boolean, AuthError> => {
    console.debug('Start logout feature');
    const confirmed = await Result.fromAsync(() => confirmLogout({}));
    if (isCancelled(confirmed.error)) {
      return Result.Ok(false);
    }
    const clientSideLogout = await confirmed
      .tap(() => dispatch(clientFavoritesSlice.actions.clearFavorites()))
      .flatMapAsync(unsubscribeNotifications);
    const serverSideLogout = await clientSideLogout.mapAsync(() => logoutRequest().unwrap());

    return serverSideLogout.mapError(unknownToAuthError);
  }, [confirmLogout, logoutRequest, unsubscribeNotifications, dispatch]);
};
